import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowUpLeftFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.25,15c-.192,0-.384-.073-.53-.22L3.47,4.53c-.293-.293-.293-.768,0-1.061s.768-.293,1.061,0L14.78,13.72c.293,.293,.293,.768,0,1.061-.146,.146-.338,.22-.53,.22Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M3.75,10.51c-.414,0-.75-.336-.75-.75V3.75c0-.414,.336-.75,.75-.75h6.011c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75H4.5v5.26c0,.414-.336,.75-.75,.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconArrowUpLeftFill18.js.map